import types from '@/actions/types';
import useConfig from '@/composables/useConfig';
import useContent from '@/composables/useContent';
import Base from '@/actions/base';
import useAnalytics from '@/composables/useAnalytics';

export default class ChangeLanguage extends Base {
  constructor(params) {
    super(params, types.CHANGE_LANGUAGE);
  }

  async execute() {
    const { setLanguage, getVariable, currentConfig, setFlowStateSystemLanguageSwitch } = useConfig();
    const { hasContent } = useContent();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      const { value, variableId } = this.params;

      let lang = value;
      let langConfig;
      const variableValue = getVariable(variableId)?.value;
      if (variableId && variableValue) {
        langConfig = currentConfig.value.contentLanguages.find((l) => l.iso639_1 === variableValue);
      } else {
        langConfig = currentConfig.value.contentLanguages.find((l) => l.code === lang);
      }

      if (!langConfig || !langConfig.active) {
        resolve();
        return;
      }

      lang = langConfig.code;

      if (hasContent(lang)) {
        setFlowStateSystemLanguageSwitch();
        setLanguage(lang);
      }

      resolve();
    });
  }

  stop() {
    if (this.resolve) {
      this.resolve();
    }
  }
}
